export type ConsentRouteContext = "patients" | "diaries";

export type ConsentSigningRoute =
    | {
          to: "/diaries/$diaryId/setup/consent/$consentId";
          params: { diaryId: string; consentId: string };
      }
    | {
          to: "/patients/$diaryId/consent/$consentId";
          params: { diaryId: string; consentId: string };
      };

export function getConsentRouteContextFromPathname(pathname: string): ConsentRouteContext {
    return pathname.startsWith("/patients/") ? "patients" : "diaries";
}

export function getConsentSigningRoute(
    diaryId: string,
    consentId: string,
    context: ConsentRouteContext
): ConsentSigningRoute {
    if (context === "patients") {
        return {
            to: "/patients/$diaryId/consent/$consentId",
            params: { diaryId, consentId },
        };
    }

    return {
        to: "/diaries/$diaryId/setup/consent/$consentId",
        params: { diaryId, consentId },
    };
}

export type ConsentCompleteRoute =
    | {
          to: "/diaries/$diaryId/setup/consent/$consentId/complete";
          params: { diaryId: string; consentId: string };
      }
    | {
          to: "/patients/$diaryId/consent/$consentId/complete";
          params: { diaryId: string; consentId: string };
      };

export function getConsentCompleteRoute(
    diaryId: string,
    consentId: string,
    context: ConsentRouteContext
): ConsentCompleteRoute {
    if (context === "patients") {
        return {
            to: "/patients/$diaryId/consent/$consentId/complete",
            params: { diaryId, consentId },
        };
    }

    return {
        to: "/diaries/$diaryId/setup/consent/$consentId/complete",
        params: { diaryId, consentId },
    };
}

export function getConsentBackRoute(diaryId: string, context: ConsentRouteContext) {
    if (context === "patients") {
        return {
            to: "/patients/$diaryId" as const,
            params: { diaryId },
        };
    }

    return {
        to: "/diaries/$diaryId/home/to-do" as const,
        params: { diaryId },
    };
}
